import { StateSpan } from '@constants/states';
import { ContactStatus } from '@efex-services/client/types';
import { Avatar } from '@efexteam/components';
import theme from '@efexteam/mui-theme';
import { TableCell, TableRow, useMediaQuery } from '@mui/material';
import { capitalize } from '@utils/formater';
import ClientsTableStyles from '../../ClientsTable.style';
import { ClientsTableRowProps } from '../../types';
import ClientRowAction from '../clientRowAction';

const StatusValue = {
  [ContactStatus.ACTIVE]: 'Active',
  [ContactStatus.INACTIVE]: 'Inactive',
  [ContactStatus.DECLINED]: 'Declined',
  [ContactStatus.PENDING]: 'Pending',
};

const ClientTableRow = ({ element, onSelect }: ClientsTableRowProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const {
    contactNaturalPersonEnterprise,
    enterpriseBankAccount,
    contactStatus,
    id,
  } = element;
  const { enterprise, naturalPerson } = contactNaturalPersonEnterprise || {};
  const { firstName, lastName, email } = naturalPerson || {};
  const { name: companyName, country, countryData } = enterprise || {};
  const { accountNumber, bankName, clabe } = enterpriseBankAccount || {};
  const contactName =
    firstName?.length || lastName?.length
      ? `${firstName} ${lastName}`
      : companyName;

  return (
    <TableRow key={id}>
      <TableCell className={ClientsTableStyles.tableCell(!isMobile)}>
        <div className={ClientsTableStyles.clientNameCell}>
          <section className="client-name-section">
            <Avatar username={contactName} size="sm" />
            <p className="client-name-text">{contactName}</p>
          </section>
        </div>
      </TableCell>
      <TableCell>{companyName ?? ''}</TableCell>
      <TableCell className={ClientsTableStyles.emailCell}>
        {email ?? ''}
      </TableCell>
      <TableCell>{accountNumber ?? clabe ?? ''}</TableCell>
      <TableCell>{bankName ?? ''}</TableCell>
      <TableCell>{countryData?.name ?? country ?? ''}</TableCell>
      <TableCell>
        <StateSpan
          status={capitalize(
            StatusValue[contactStatus?.id ?? ContactStatus.ACTIVE]
          )}
        />
      </TableCell>
      <ClientRowAction client={element} onSelect={onSelect} />
    </TableRow>
  );
};

export default ClientTableRow;
